module.exports = __webpack_public_path__ + "static/media/YM72_3.01d94075.jpg";